import { z } from "zod";

export const Organization = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string().optional().nullish(),
});
